import { isEqual, isEmpty, pick, mapValues } from 'lodash-es';
import { ADDRESS_ERRORS, ADDRESS_FIELDS } from '../constants';

const toLowerCase = value => value && value.toLowerCase();

export function AddressDuplicateValidator() {
  return {
    require: 'ngModel',
    restrict: 'A',
    link,
  };

  function link(scope, element, attrs, ctrl) {
    // Set allowInvalid so angular doesn't set the model to
    // undefined when invalid so we can compare the model values
    ctrl.$overrideModelOptions({
      allowInvalid: true,
    });

    const getDependentModelValue = () => scope.$eval(attrs.updAddressDuplicate);

    scope.$watch(getDependentModelValue, () => ctrl.$validate());

    ctrl.$validators[ADDRESS_ERRORS.DUPLICATE] = (modelValue, viewValue) => {
      const value = modelValue || viewValue || {};
      const models = [value, getDependentModelValue()];
      return areAllModelsEmpty(models) || !areModelsEqual(models);
    };
  }
}

function areAllModelsEmpty(models) {
  return models.every(model => isEmpty(getBaseAddressFields(model)));
}

function areModelsEqual([model1, model2]) {
  return isEqual(getBaseAddressFields(model1), getBaseAddressFields(model2));
}

function getBaseAddressFields(address) {
  const selectFields = [
    ADDRESS_FIELDS.STREET,
    ADDRESS_FIELDS.APT,
    ADDRESS_FIELDS.CITY,
    ADDRESS_FIELDS.STATE,
    ADDRESS_FIELDS.ZIP,
  ];

  return mapValues(pick(address, selectFields), toLowerCase);
}
